export enum WorkflowConfigFieldInputType {
    STRING = 'string',
    NUMBER = 'number',
    TEXT = 'text',
    DATE = 'date',
    BOOLEAN = 'boolean',
    DECIMAL = 'decimal',
    FLOAT = 'float'
}
